import { contacts, BRAND, SCHOOLS, YEAR } from "@/data/clubs";
import { waHref } from "@/lib/contact";

export const Footer = () => (
  <footer className="bg-ink text-paper px-5 md:px-10 py-16">
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 border-b border-white/10 pb-12">
        <div>
          <div className="flex items-center gap-3">
            <img src="/logo.webp" alt="לוגו ספורט והעשרה" className="w-12 h-12 object-contain bg-white rounded-full p-1" />
            <div className="leading-tight">
              <div className="font-head font-black text-2xl">{BRAND}</div>
              <div className="text-white/50 text-sm">{SCHOOLS.join(" · ")}</div>
            </div>
          </div>
          <p className="mt-4 text-white/50 max-w-sm leading-relaxed">
            חוגי ספורט והעשרה — {YEAR}. מרחב לגדול, לגלות וליהנות.
          </p>
        </div>
        <div className="flex flex-wrap gap-8">
          {contacts.map((c) => (
            <div key={c.phone}>
              <div className="text-white/40 text-sm">{c.name}</div>
              <a
                href={waHref(c.phone)}
                target="_blank"
                rel="noopener noreferrer"
                className="font-head font-bold text-lg tabular-nums link-underline"
                dir="ltr"
              >
                {c.phone}
              </a>
            </div>
          ))}
        </div>
      </div>
      <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-white/40 text-sm">
        <span>© {new Date().getFullYear()} ספורט והעשרה · מעיינות · הדסים · צורים. כל הזכויות שמורות.</span>
        <span>נבנה באהבה עבור הילדים שלנו</span>
      </div>
    </div>
  </footer>
);
